const recurrings = {
  id: 'ID',
  contact_id: 'Contact',
  title: 'Title',
  contact_first_name: 'First Name',
  contact_last_name: 'Last Name',
  contact_company_name: 'Company',
  contact_email: 'Email',
  amount: 'Amount',
  frequency: 'Frequency',
  start_date: 'Start Date',
  next_date: 'Next Date',
  end_date: 'End Date',
  state: 'Status',
  create_invoice: 'Create Invoice',
  create_payment: 'Create Payment',
  send_invoice_by_email: 'Send Invoice by Email',
  source: 'Source',
  last_invoice_status: 'Last Invoice Status',
  last_payment_status: 'Last Payment Status',
  invoice_counter: 'Invoice Count',
  payment_counter: 'Payment Count',
  invoice_failure_count: 'Invoice Failures',
  payment_failure_count: 'Payment Failures',
  payment_info: 'Payment Method',
  payment_type: 'Payment Type',
  cc_expiration: 'Credit Card Expiration',
  bank_account_id: 'Bank Account',
  invoice_id: 'Invoice',
  payment_id: 'Payment',
  template_invoice: 'Template Invoice',
  edit_template_invoice: 'Edit Template Invoice',
};

export default recurrings;
